import { render, staticRenderFns } from "./OrderNumbers.vue?vue&type=template&id=137eb010&"
import script from "./OrderNumbers.vue?vue&type=script&lang=js&"
export * from "./OrderNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports